<template>
  <form @submit.prevent="submit" v-if="!error">
    <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 3 из 6</span></h2>
    <h3 class="form__subtitle" v-if="!error || error !== 2">Паспортные данные</h3>
    <h3 class="form__subtitle form__subtitle-bold" v-else>Требуется повторная загрузка документов</h3>
    <div class="form__description">
      <p>
        Данные паспорта необходимы нам, чтобы удостовериться, что вы являетесь совершеннолетним потребителем табачной продукции. При&nbsp;сканировании разворота паспорта с&nbsp;вашими личными данными закройте фотографию в&nbsp;документе. Изображение должно быть с&nbsp;чёткими буквами и&nbsp;цифрами, без&nbsp;явных теней и&nbsp;изломов.
      </p>
    </div>
    <div class="form-row form-row_no-flex">
      <file-input input-name="file1" @change="onChangeFile1">
        <template #title>
          Разворот с фотографией (2&nbsp;и&nbsp;3 страницы паспорта)
        </template>
        <template #errors>
          <div class="fileinput__error" v-if="$v.form.file1.$error">
            <div v-if="!$v.form.file1.required">Выберите файл</div>
          </div>
        </template>
      </file-input>
      <p class="form__footnote">Допустимый формат файла JPG, PNG, GIF, BMP (размер не&nbsp;более 10&nbsp;Мб)</p>
    </div>

    <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
      <template #errors>
        <div class="text-input__error">
          <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
        </div>
      </template>
    </smart-captcha>

    <div class="form-row form-row_mobile-wrap form-row_align-center">
      <button class="form__submit button button__lg button__blue" type="submit">Продолжить</button>
    </div>
    <div class="form-row form-row_mobile-wrap form-row_align-center">
      <delete-questionnaire-btn />
    </div>
  </form>
  <div class="sign-up-error" v-else>
    <template v-if="error === 1">
      <h2 class="form__title">Документы не&nbsp;прошли проверку</h2>
      <p class="form__description form__description_align-center-all">
        К&nbsp;сожалению, ваши анкетные данные не&nbsp;прошли проверку. Анкета будет автоматически удалена в&nbsp;течение 24&nbsp;часов.
      </p>
      <p class="form__description form__description_align-center-all">
        После этого вы сможете повторить регистрацию.
      </p>
      <!--
      <div class="form-row form-row_mobile-wrap form-row_align-center">
        <delete-questionnaire-btn />
      </div>
      -->
      <div class="form-row form-row_align-center form__actions">
        <a class="button button__lg button__blue" href="/">Перейти на&nbsp;главную</a>
      </div>
    </template>
    <template v-else-if="error === 3">
      <h2 class="form__title">Ошибка загрузки</h2>
      <p class="form__description form__description_align-center-all">
        Пожалуйста, загрузите отсканированный разворот паспорта повторно.
      </p>
      <div class="form-row form-row_align-center form__actions">
        <a class="button button__lg button__blue" @click.prevent="runNextIteration">Продолжить</a>
      </div>
    </template>
    <template v-else-if="error === 10">
      <h2 class="form__title">Системная ошибка</h2>
      <p class="form__description form__description_align-center">
        Пожалуйста, повторите попытку позже, или обратитесь <br/>в&nbsp;службу поддержки.
      </p>
    </template>
    <template v-else-if="showDelayedUploadMessage">
      <h2 class="form__title">Ошибка загрузки</h2>
      <p class="form__description form__description_align-center-all">
        Пожалуйста, загрузите отсканированный разворот паспорта повторно.
      </p>
      <div class="form-row form-row_align-center form__actions">
        <a class="button button__lg button__blue" @click.prevent="hideDelayedUploadMessage">Продолжить</a>
      </div>
    </template>
    <template v-else>
      <p class="form__description form__description_align-center" v-html="errorMsg" />
    </template>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import api from "../services/api";
import FileInput from './FileInput';
import DeleteQuestionnaireBtn from "./DeleteQuestionnaireBtn";
import SmartCaptcha from "./SmartCaptcha.vue";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

export default {
  name: "SignUpStepDocument",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    DeleteQuestionnaireBtn,
    FileInput,
  },
  props: {
    showDelayedUploadMessage: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      error: null,
      iteration: 1,
      form: {
        file1: null,
        captcha: ''
      },
      errorMsg: '',
    };
  },
  validations: {
    form: {
      file1: {required},
      captcha: {required},
    }
  },
  methods: {
    onChangeFile1(file) {
      this.form.file1 = file;
    },
    goNext() {
      this.$emit('complete');
    },
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();
      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        await this.$store.dispatch('showLoader');
        try {
          this.error = null;
          const result = await api.registerStepDocument(this.iteration, this.form.file1);
          if (result) {
            // можно переходить на шаг подтверждения email
            this.$emit('complete', 'validated');
            await this.$store.dispatch('hideErrorsBag');
          }
        } catch (e) {
          // Removing debug error with code 0
          const filteredErrors = e.errors.filter(error => error.code !== 0);
          this.error = filteredErrors[0].code;
          this.errorMsg = filteredErrors[0].message;
          if ([3,4,5].indexOf(this.error) < 0 ) {
            await this.$store.dispatch('setErrors', e);
          }
          switch (this.error) {
            case 1: // Сервис IDX недоступен, блокировка
              //await this.$store.dispatch('goblocked');
              break;
            case 2: // IDX ошибка "-200", некорректное изображение, грузим заново, проверим снова через parsePassportAuto
              this.form.file1 = null;
              break;
            case 3: // Просим пользователя повторно загрузить документы для проверки на бэке другим методом
              break;
            case 4: // Паспорт не проверили, но пока что можно идти дальше и вернуться к этому шагу после остальных шагов
              this.$emit('complete', 'suggested-delay');
              break;
            case 5: // Паспорт проверен через Jti.v3.CustomerIDXverification, можно переходить на шаг подтверждения e-mail
              //await this.$store.dispatch('goToInfoAboutPassportCheck');
              this.$emit('complete', 'validated');
              break;
          }
        } finally {
          await this.$store.dispatch('hideLoader');
        }
      }
    },
    runNextIteration() {
      this.iteration++;
      this.error = null;
    },
    hideDelayedUploadMessage() {
      this.$emit('hide-delayed-upload-message');
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../scss/base/_settings.scss";
.sign-up-error {
  margin-top: -10px;
  margin-bottom: -15px;
  @include mobile {
    margin: 0;
  }
  .form__title {
    margin-bottom: 34px;
  }
  .form__description {
    font-size: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .form__nav {
    margin-top: 58px;
  }
}
</style>
